/**
 * Documentation Constants
 * Shared constants for documentation system
 */

/**
 * Categories for organizing documentation
 */
export const documentationCategories = {
  CALENDAR: 'setup your calendar',
  SCHEDULE: 'edit your classes/events',
  CLASS_SCHEDULING: 'class scheduling',
  SUBJECTS: 'subjects',
  AVAILABILITY: 'availability',
  UI: 'ui',
  SETTINGS: 'settings',
  IMPORT_EXPORT: 'import-export',
  NOTIFICATIONS: 'notifications',
  APP_ONLY: 'app-only',
}; 

/**
 * Order in which categories should be displayed
 */
export const categoryOrder = [
  documentationCategories.CALENDAR,
  documentationCategories.SCHEDULE,
  documentationCategories.CLASS_SCHEDULING,
  documentationCategories.SUBJECTS,
  documentationCategories.AVAILABILITY,
  documentationCategories.UI,
  documentationCategories.SETTINGS,
  documentationCategories.IMPORT_EXPORT,
  documentationCategories.NOTIFICATIONS,
]; 